import { type OnboardingFormValues } from "../../wizard/types/onboardingFormValues"
import { OnboardingPostOctoshieldEvents } from "../constants/onboardingPostOctoshieldEvents"
import { type OnboardingDataLayerEvent } from "../types/onboardingDataLayerEvent"

const RISK_LEVEL_SCORE_MAP = {
    LOW: 1,
    MEDIUM: 0.75,
    HIGH: 0.5,
}

export const getOctoshieldEventData = (
    event: OnboardingDataLayerEvent,
    formValues: OnboardingFormValues
) => {
    if (!OnboardingPostOctoshieldEvents.includes(event)) return {}

    return {
        customer_score: formValues.riskLevel,
        deposit_type: formValues.depositType ?? "NA",
        // TODO : Delete global_score once the marketing team confirms that they are not using this field anymore
        global_score: RISK_LEVEL_SCORE_MAP[formValues.riskLevel],
    }
}
